/**
 * @generated SignedSource<<2d900ebfbff7df7a3722aa8c581cb13c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects$data = {
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment" | "ui_projectNotificationsModal_ProjectNotificationsModal">;
  readonly " $fragmentType": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects";
};
export type projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects$key = {
  readonly " $data"?: projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_projectNotificationsModal_ProjectNotificationsModal"
    }
  ],
  "type": "Query"
};

(node as any).hash = "1a4f4da7c189163bef79a5b3dda3d45f";

export default node;
